module.exports = __webpack_public_path__ + "img/02-blue.6bfe6108.png";